import React, { useState, useEffect } from 'react';
import { EmailSignalEngine } from '../../utils/emailSignalData';
import { Button } from '../ui/button';

export default function ConnectorSetup({ onSetup }) {
  const [org, setOrg] = useState(null);
  const [handoff, setHandoff] = useState(null);

  useEffect(() => {
    setOrg(EmailSignalEngine.getOrg());
    setHandoff(EmailSignalEngine.getITHandoffData());
  }, []);

  const handleSetup = () => {
    EmailSignalEngine.setupConnector();
    setOrg(EmailSignalEngine.getOrg());
    setHandoff(EmailSignalEngine.getITHandoffData());
    onSetup?.();
  };

  const downloadHandoff = () => {
    const data = handoff || EmailSignalEngine.getITHandoffData();
    const text = `
NexoNurse Email Connector — IT Handoff

Ingestion address (BCC target):
${data.ingestionEmail}

Recommended distribution lists to include:
${(data.recommendedLists || []).join('\n')}

Instructions:
${data.mailRuleInstructions}

Configure a mail flow rule to BCC all messages to/from the above lists to the ingestion address.
Do not store body or attachments. Headers only.
    `.trim();
    const blob = new Blob([text], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'nexonurse-email-connector-handoff.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  if (!org) return null;

  return (
    <div className="space-y-6">
      <div className="bg-nn-white rounded-[14px] shadow-card overflow-hidden hover:shadow-md transition-shadow relative">
        <div className="px-5 py-4 flex justify-between items-center">
          <div className="font-heading text-[14px] font-semibold text-text-dark">Email connector</div>
        </div>
        <div className="p-5">
          {org.connectorStatus === 'not_setup' && !org.ingestionEmail && (
            <>
              <p className="text-text-muted" style={{ marginBottom: 16 }}>
                Set up the Email Signal Engine by generating a unique ingestion address and an IT handoff document.
                No end-user behavior change — IT configures a BCC rule once.
              </p>
              <Button variant="primary" size="sm" type="button" onClick={handleSetup}>
                Initialize connector
              </Button>
            </>
          )}

          {(org.connectorStatus === 'calibrating' || org.connectorStatus === 'active' || org.ingestionEmail) && (
            <>
              <div style={{ marginBottom: 16 }}>
                <label className="text-body-sm font-semibold text-text-muted" style={{ display: 'block', marginBottom: 4 }}>Ingestion email address</label>
                <div className="text-body" style={{ padding: 12, background: '#F3F4F6', borderRadius: 8, fontFamily: 'monospace' }}>
                  {org.ingestionEmail || handoff?.ingestionEmail}
                </div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label className="text-body-sm font-semibold text-text-muted" style={{ display: 'block', marginBottom: 4 }}>Recommended distribution lists</label>
                <ul style={{ paddingLeft: 20, color: '#374151' }}>
                  {(handoff?.recommendedLists || []).map((list, i) => (
                    <li key={i}>{list}</li>
                  ))}
                </ul>
              </div>
              <p className="text-body text-text-muted" style={{ marginBottom: 16 }}>
                {handoff?.mailRuleInstructions}
              </p>
              <Button variant="default" size="sm" type="button" onClick={downloadHandoff}>
                Download IT handoff (TXT)
              </Button>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
